export namespace AlarmsManagerModel {
  export enum AlarmStatus {
    ACTIVE = 0,
    TIMEOUT = 1,
    CLOSED = 2,
  }

  export interface Alarm {
    id: number;
    orgId: string;
    locationId: string;
    orgIdHash: number;
    locationIdHash: number;
    status: AlarmStatus;
    alertIdsList: string[];
    createdAt: number;
    updatedAt: number;
    timeoutAt?: number;
    closedAt?: number;
    statusChangedByUser?: string;
  }

  export interface AlarmWithAlerts extends Alarm {
    alerts: AlertInstance[];
  }

  export interface AlertInstance {
    alertInstanceId: number;
    timestamp: number;
    eventName?: string;
    alertMessage?: string;
  }

  export interface AlarmListResponse {
    alarms: Alarm[];
    total: number;
    page: number;
    limit: number;
  }

  export interface AlarmStatsResponse {
    total: number;
    active: number;
    timeout: number;
    closed: number;
  }

  export interface GetAlarmsQuery {
    page?: number;
    limit?: number;
    status?: AlarmStatus;
    locationId?: string;
    fromDate?: string;
    toDate?: string;
  }

  export interface AlarmAlertDetails {
    eventId: string;
    eventName: string;
    eventType: string;
    alertInstanceId: string;
    locationId: string;
    edgeId: string;
    cameraId: string;
    cameraName: string;
    alertMessage: string;
    timestamp: number;
    flowLookup: {
      category: number;
      flowType: number;
    };
  }

  export interface CloseAlarmRequest {
    userId: string;
  }
}